import { render, staticRenderFns } from "./RelatoView.vue?vue&type=template&id=0f2adaef&scoped=true"
import script from "./RelatoView.vue?vue&type=script&lang=js"
export * from "./RelatoView.vue?vue&type=script&lang=js"
import style0 from "./RelatoView.vue?vue&type=style&index=0&id=0f2adaef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2adaef",
  null
  
)

export default component.exports